import { combineReducers } from 'redux';
import userReducer from 'shared/reducers/userReducer';
import storyReducer from 'shared/reducers/storyReducer';
import screenReducer from 'shared/reducers/screenReducer';
import modalReducer from 'shared/reducers/modalReducer';
import navReducer from 'shared/reducers/navReducer';
import photoSwipeReducer from 'shared/reducers/photoSwipeReducer';
import selectionReducer from 'shared/reducers/selectionReducer';
import progressBarReducer from 'shared/reducers/progressBarReducer';
import homeReducer from 'shared/reducers/homeReducer';
import cartReducer from 'shared/reducers/cartReducer';
import profilePageReducer from 'shared/reducers/profilePageReducer';
import messagesReducer from 'shared/reducers/messagesReducer';

export default combineReducers({
  userReducer,
  storyReducer,
  screenReducer,
  modalReducer,
  navReducer,
  photoSwipeReducer,
  selectionReducer,
  progressBarReducer,
  homeReducer,
  cartReducer,
  profilePageReducer,
  messagesReducer
});
